import { flow } from 'fp-ts/function';
import { lens } from 'monocle-ts/Lens';
export var withDefault = function withDefault(defaultValue) {
  return function (sa) {
    return lens(flow(sa.get, function (a) {
      return a !== null && a !== void 0 ? a : defaultValue;
    }), sa.set);
  };
};